<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-toolbar class="light-blue darken-4 light-blue--text text--lighten-5">
          <v-toolbar-title>Фискальная операция</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                :value="format(new Date(fiscal.created), 'dd MMMM yyyy HH:mm' , {locale: ru})"
                readonly
                label="Дата создания"
              />
            </v-col>
            <v-col>
              <v-text-field
                :value="format(new Date(fiscal.updated), 'dd MMMM yyyy HH:mm', {locale: ru})"
                readonly
                label="Дата обработки"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                :value="fiscal.number"
                readonly
                label="Номер"
              />
            </v-col>
            <v-col>
              <v-text-field
                :value="fiscal.payment_number"
                readonly
                label="Номер платежа"
              />
            </v-col>
            <v-col>
              <v-text-field
                :value="fiscal.request.payment.type"
                readonly
                label="Признак расчёта"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                :value="fiscal.settings.rn"
                readonly
                label="РН ККТ"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.data ? fiscal.data.device.sn: ''"
                label="Заводской номер ККТ"
              />
            </v-col>
            <v-col>
              <v-text-field
                :value="fiscal.request.payment.sum"
                readonly
                label="Сумма"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.data ? fiscal.data.cheque.fp : ''"
                label="ФП документа"
              />
            </v-col>
            <v-col>
              <v-text-field
                :value="action[fiscal.request.action]"
                readonly
                label="Тип операции"
              />
            </v-col>
            <v-col>
              <v-text-field
                :value="state[fiscal.state]"
                readonly
                label="Статус"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.data ? fiscal.data.device.number : ''"
                label="Номер фискального накопителя"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.data ? fiscal.data.cheque.fd_number: ''"
                label="Номер ФД"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.data ? fiscal.data.cheque.shift_number : ''"
                label="Номер смены"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.data ? fiscal.data.cheque.cheque_number : ''"
                label="Номер чека за смену"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.settings ? fiscal.settings.ofd.name: ''"
                label="Наименование ОФД"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.settings ? fiscal.settings.ofd.server : ''"
                label="Web-сайт ОФД"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.request ? fiscal.request.payment.items[0].attributes.payer_doc_number : ''"
                label="ИНН пользователя"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.settings ? fiscal.settings.owner.address: ''"
                label="Адрес"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.settings ? fiscal.settings.owner.place : ''"
                label="Место расчета"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.request ? fiscal.request.cashier.name : ''"
                label="Кассир"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.srequest ? fiscal.request.cashier.inn: ''"
                label="ИНН кассира"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.request ? fiscal.request.payment.items[0].name : ''"
                label="Предмет расчета"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.request ? fiscal.request.payment.items[0].agent.nameOperatorTransaction : ''"
                label="Наименование агента"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.srequest ? fiscal.request.payment.items[0].agent.innOperatorTransaction: ''"
                label="ИНН агента"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.request ? fiscal.request.payment.items[0].agent.supplierName : ''"
                label="Получатель"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.request ? fiscal.request.payment.items[0].attributes.payer_fio : ''"
                label="Плательщик"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.additional ? fiscal.additional.message: ''"
                label="Дополнительно"
              />
            </v-col>
            <v-col>
              <v-text-field
                readonly
                :value="fiscal.request ? fiscal.request.payment.items[0].agent.supplierName : ''"
                label="Получатель"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col
              class="d-flex justify-center"
              cols="12"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Назад</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { JustpayFiscalService } from "@/views/loyalty/shared/services/justpay-fiscal-service"
import { tryGet } from "@/views/loyalty/shared/modules/utilities"
import { format } from "date-fns-tz"
import { ru } from "date-fns/locale"

export default {
  computed: {
    ru () {
      return ru
    }
  },
  data: () => ({
    fiscal: {},
    fiscal_init: {
      request: {
        payment: {
          items: [{
              attributes: {
                payer_doc_number: '',
              },
            agent: {
              nameOperatorTransaction: '',
              innOperatorTransaction: '',
              supplierName: ''

            }
            }
          ],
          sum: 0,
          type: ''
        }
      }
    },
    justpayFiscalService: null,
    state: {
      0: 'Новый',
      1: 'В обработке',
      2: 'Завершен',
      3: 'Отменен',
      4: 'Ошибка'
    },
    action: {
      0: 'Регистрация фискального режима',
      1: 'Закрытие фискального режима',
      2: 'Открытие смены',
      3: 'Закрытие смены',
      4: 'Печать отчета',
      5: 'Создание заказа',
      6: 'Печать HTML',
      7: 'Доп.информация',
      8: 'Статус операции',
      9: 'Отмена документа'
    }

  }),
  beforeMount () {
    this.justpayFiscalService = new JustpayFiscalService()
  },
  async mounted () {
    const fiscalId = this.$route.query.id
    const result = await this.justpayFiscalService.getList({ id: fiscalId })
    if (!result.error) {
      this.fiscal = result.data[0]
      this.fiscal.request.payment = this.fiscal.request.payment || this.fiscal_init.request.payment
      this.fiscal.request.payment.items[0].attributes = this.fiscal.request.payment.items[0].attributes || this.fiscal_init.request.payment.items[0].attributes
      this.fiscal.request.payment.items[0].agent = this.fiscal.request.payment.items[0].agent || this.fiscal_init.request.payment.items[0].agent
    }
  },
  methods: { format, tryGet }
}
</script>
<style scoped>

</style>
